<div class="slot-messages">
  <% _.each(slot_messages, function(slot_message) { %>
    <%= renderPartial('appointment_booking/wizard/templates/messages/slot_message', { slot_message: slot_message }) %>
  <% }) %>
</div>
